import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Automatically reload when a dynamic chunk import fails due to a new deployment replacing asset hashes
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const lastReload = Number(sessionStorage.getItem('vite_preload_reload') || '0');
  const now = Date.now();
  if (now - lastReload > 10000) {
    sessionStorage.setItem('vite_preload_reload', String(now));
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);